import { api } from "api/api";
import { AxiosError } from "axios";
import Page from "model/page/Page";
import Pageable from "model/page/Pageable";
import InspecaoQualidade from "model/qualidade/InspecaoQualidade";
import PlanoInspecao from "model/qualidade/PlanoInspecao";
import { DataTableFilterMeta, DataTableOperatorFilterMetaData } from "primereact/datatable";
import { Value } from "sass";
import { BaseServiceCadastros } from "service/BaseServiceCadastros";
import { getFilters } from "utils/filterUtils";
import { generateKey } from "utils/generateKey";

class PlanoInspecaoService implements BaseServiceCadastros<PlanoInspecao> {

    pesquisar(page: Pageable, filters?: DataTableFilterMeta | null) {
        return new Promise<Page>((resolve, reject): void => {
            let url = `/planoInspecao/pesquisar`;
            url += getFilters(filters);

            const params = {
                page: page.page,
                size: page.size,
                sort: page.sort,
            };

            api
                .get(url, { params })
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    consultar(id: number) {
        return new Promise<PlanoInspecao>((resolve, reject): void => {
            api
                .get(`/planoInspecao/consultar/${id}`)
                .then(response => {

                    const planoInspecao = response.data as PlanoInspecao;

                    planoInspecao.itens = planoInspecao.itens.map((item: any) => {
                        return {
                            ...item,
                            key: generateKey()
                        }
                    });

                    resolve(planoInspecao)
                })
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    incluir(planoInspecao: PlanoInspecao) {
        return new Promise<PlanoInspecao>((resolve, reject): void => {
            api
                .post(`/planoInspecao/incluir`, JSON.stringify(planoInspecao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    editar(planoInspecao: PlanoInspecao) {
        return new Promise<PlanoInspecao>((resolve, reject): void => {
            api
                .put(`/planoInspecao/editar`, JSON.stringify(planoInspecao))
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    excluir(id: number) {
        return new Promise<void>((resolve, reject): void => {
            api
                .delete(`/planoInspecao/excluir/${id}`)
                .then(() => resolve())
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    getFases() {
        return [
            { label: 'Produto acabado', value: 'PRODUTO_ACABADO' },
            { label: "Estágio de produção", value: "ESTAGIO_PRODUCAO" },
            { label: "Recebimento", value: "RECEBIMENTO" },
        ]
    }

    getFase(fase: string) {
        return this.getFases().find(item => item.value === fase)?.label || "";
    }

    getFaseFilter(){
        return [
            {label: 'Produto acabado', value: 'ACA'},
            {label: 'Estágio de produção', value: 'PRD'},
            {label: 'Recebimento', value: 'REC'}
        ]
    }

    getInspecoes(){
        return new Promise<InspecaoQualidade[]>((resolve, reject): void => {
            api
                .get(`/planoInspecao/inspecoes`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

    proximoCodigo(){
        return new Promise<string>((resolve, reject): void => {
            api
                .get(`/planoInspecao/proximoCodigo`)
                .then(response => resolve(response.data))
                .catch((err: AxiosError) => reject(err.response));
        });
    }

}

export default PlanoInspecaoService;